/* unplugin-vue-components disabled */import { render } from "./MenuBox.vue?vue&type=template&id=1c03423a"
import script from "./MenuBox.vue?vue&type=script&lang=js"
export * from "./MenuBox.vue?vue&type=script&lang=js"

import "./MenuBox.vue?vue&type=style&index=0&id=1c03423a&lang=less&scope=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__